import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
/**
 * Renders the "Draft" and (optional) "Scheduled" status pills for a poll.
 * Shared between the poll list row and the poll view page so both surfaces
 * expose the same visual cue.
 */
export default class PollDraftBadges extends Component {
  view() {
    const poll = this.attrs.poll;
    if (!poll.isDraft()) return null;
    return m("span", {
      className: "PollDraftBadges"
    }, m("span", {
      className: "PollDraftBadges-draft",
      title: app.translator.trans('fof-polls.forum.poll.draft_label')
    }, m("i", {
      className: "icon fa-solid fa-pencil-alt"
    }), " ", app.translator.trans('fof-polls.forum.poll.draft_label')), poll.isScheduled() && m("span", {
      className: "PollDraftBadges-scheduled"
    }, m("i", {
      className: "icon fa-solid fa-clock"
    }), ' ', app.translator.trans('fof-polls.forum.poll.scheduled_label', {
      date: dayjs(poll.scheduledPublishAt()).format('lll')
    }), poll.scheduledPublishError() && m("span", {
      className: "PollDraftBadges-scheduleError",
      title: poll.scheduledPublishError()
    }, m("i", {
      className: "icon fa-solid fa-exclamation-triangle"
    }))));
  }
}
flarum.reg.add('fof-polls', 'forum/components/Poll/PollDraftBadges', PollDraftBadges);